<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka AI Entende<br /> Redação Médica</h1>
                        <p>O verificador poderoso Trinka reconhece as sutilezas e a precisão técnica exigidas na redação médica
                            e científica e transforma a sua redação para torná-la mais envolvente, formal e pronta para publicação.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma Cotação</button>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/medical.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>Soluções Adequadas para Organizações em:</h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>Dispositivos Médicos e Farmacêuticos</li>
                            <li>Biotecnologia e Ciências Biológicas</li>
                            <li>Pesquisa Terceirizada</li>
                            <li>Publicação Médica e Científica</li>
                            <li>Regulação e Farmacovigilância</li>
                            <li>Comunicações Médicas & Marketing</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>Aprovado por Líderes Globais</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/j-j.png" alt="Client Logo">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/cigna.png" alt="Client Logo">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/novartis.png" alt="Novartis">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/merck.png" alt="Merck">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/abbvie.png" alt="Abbvie">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/amgen.png" alt="Amgen">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/biogen.png" alt="Biogen">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/who.png" alt="Who">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/accelera.png" alt="Accelera">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/pfizer.png" alt="Pfizer">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>Assistência de Redação de Alta Qualidade para suas Equipes</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka auxilia suas equipes na criação de documentos críticos de forma eficiente, garantindo qualidade
                            e conformidade com as convenções de redação científica.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/MedicalSpellCheckicon.svg" alt="Spell Check" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Verificação Ortográfica Médica e Dicionário</h3>
                                    <p>O dicionário médico integrado de Trinka contém milhares de termos de todos os campos
                                        da medicina. Você também pode adicionar o léxico da sua organização e novos termos
                                        para permanecer na marca em todas as comunicações e personalizar a sua assistência
                                        à redação.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/StyleGuides.png" alt="Style Guide" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Guias de Estilo Embutidos e Personalizados</h3>
                                    <p>Trinka torna o cumprimento de guias de estilo técnico, como AMA (Associação Médica Americana)
                                        e APA (Associação de Psicologia Americana), uma brisa com correções para todas as
                                        preferências de redação em poucos cliques. Padronize toda a sua comunicação entre
                                        as equipes também com guias de estilo de marca personalizados.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/PublicationReadiness.svg" alt="Style Guide" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Preparação para Publicação</h3>
                                    <p>Trinka verifica os artigos de pesquisa em relação a mais de 20 requisitos de prontidão
                                        para publicação para ajudar suas equipes a publicarem mais rapidamente, permitindo
                                        que você fortaleça o portfólio de pesquisa da sua marca com mais rapidez.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="PPC Icon" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Verificação de Plágio </h3>
                                    <p>A mais alta qualidade de verificação de plágio, com o algoritmo mais avançado de detecção de semelhança de textos, iThenticate e o maior banco de dados de publicações pagas.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/BulkEditingOperations.svg" alt="Bulk Edit Operation" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Operações de Edição em Massa</h3>
                                    <p>Carregue seus documentos em formato MS Word e relaxe enquanto Trinka os edita em minutos.
                                        Basta baixar os arquivos editados com todas as sugestões aplicadas nas alterações
                                        rastreadas para revisar e finalizar.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="Comprehensive Analytics" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Análise Abrangente</h3>
                                    <p>Veja como suas equipes usam Trinka ou aprofunde-se na atividade de cada usuário com análises
                                        ricas para uma tomada de decisão eficaz.</p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="Easy User Management" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Gerenciamento Fácil de Usuários</h3>
                                    <p>Sua conta de equipe permite que você adicione ou remova membros facilmente. Gerencie créditos e limites de uso em tempo real. O gerenciamento de acesso é fácil e seguro com os
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="Dedicated Support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Suporte Dedicado</h3>
                                    <p>Um gerente de sucesso dedicado é designado para apoiar a sua equipe para obter o máximo
                                        de Trinka. Isso inclui uma chamada de integração minuciosa, documentação de ajuda
                                        e orientações em vídeo.
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>Assistência para Todos os Casos de Uso</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Descubra o verdadeiro poder de Trinka para redação médica com a ajuda de casos de uso personalizado para
                        setores e funções específicas.</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Redação de Artigo de Pesquisa</h4>
                                <p>A assistência de redação de Trinka é adaptada para artigos de pesquisa e comunicações.</p>
                                <ul>
                                    <li>Correções de terminologia para assuntos específicos</li>
                                    <li>Preferências de guia de estilo</li>
                                    <li>Verificações de prontidão para publicação</li>
                                    <li>Correspondência do escopo do periódico</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Dicionário Científico e Léxico da Marca</h4>
                                <p>Trinka ajuda a sua organização a padronizar as comunicações e manter a marca.</p>
                                <ul>
                                    <li>Dicionários personalizados de equipe ou organização</li>
                                    <li>Detecção e correção de erros precisas para termos científicos</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Comunicação Eficaz da Marca</h4>
                                <p>Ajudeas suas equipes a alcançar o público-alvo com facilidade, mantendo a marca.</p>
                                <ul>
                                    <li>Melhora tom e clareza</li>
                                    <li>Melhorias técnicas do fraseado</li>
                                    <li>Elimina redação fragmentada</li>
                                    <li>Guias de estilo da marca personalizados</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Revisão de Artigos de Pesquisa</h4>
                                <p>Construa seu portfólio de pesquisa com facilidade com recursos focados em publicações.</p>
                                <ul>
                                    <li>Verificações de qualidade da linguagem</li>
                                    <li>Verificações da consistência</li>
                                    <li>Verificações de prontidão para publicação</li>
                                    <li>Opções de edição em massa</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>Integre com seu Software Proprietário e Fluxos de Trabalho</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>As integrações fáceis de Trinka permitem que suas equipes desfrutem de todos os benefícios diretamente no
                    software existente, tornando a escrita eficaz, produtiva e contínua.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>JavaScript</h3>

                    <p>
                        Habilite Trinka para todos os membros de sua equipe simplesmente inserindo um pequeno trecho de código JavaScript (JS) em
                        seu navegador ou qualquer aplicativo.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>API</h3>
                    <p>
                        O poderoso verificador Trinka API traz Trinka direto para seus aplicativos existentes. Com uma arquitetura de API simples,
                        é fácil de integrar.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Na Premissa</h3>
                    <p>Garanta uma redação eficaz e máxima confidencialidade com Trinka hospedado em sua infraestrutura corporativa,
                        seja em servidores locais ou em nuvem.
                    </p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Cloud Editor</h3>


                    <p>
                        Use todo o potencial de Trinka em qualquer lugar, com o aplicativo seguro baseado na web.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Suplemento MS Word</h3>
                    <p>
                        Aumente a produtividade de suas equipes com sugestões de redação fornecidas no MS Word.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>Plug-ins no Navegador</h3>
                    <p>
                        Assistência de redação em tempo real em qualquer site da Web por meio de plug-ins para todos os seus navegadores favoritos.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>Preços Personalizados que Funcionam para você</h2>
                </div>
                <p>Trinka oferece preços flexíveis para usuário ou baseados no uso para atender às suas necessidades exclusivas.
                    <br>Troque de usuário e aplique restrições de uso em tempo real, sem nenhum custo extra.
                    <br>Trabalharemos com você para criar um contrato personalizado sem complicações e uma opção de pagamento
                    único por meio de pedido de compra / fatura. </p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma cotação</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Seguro e confiável</h3>
                        <p>Trinka coloca a segurança e a privacidade dos dados em primeiro plano. Todos os seus dados são fortemente
                            criptografados e armazenados com segurança - ninguém mais tem acesso aos seus dados. Oferecemos
                            planos exclusivos que eliminam completamente o salvamento de qualquer dado assim que você receber
                            sugestões de redação.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="Safe Secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="About AI" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Sobre a AI</h3>
                        <p>Trinka usa as mais recentes técnicas de aprendizado de máquina (ML) e processamento de linguagem
                            natural (PNL) para identificar erros gramaticais e sugerir aprimoramentos de linguagem. Ele é
                            treinado em milhões de documentos e artigos bem escritos que abrangem mais de 1300 áreas, incluindo
                            medicina, ciências biológicas, biologia , ciências físicas, engenharia, humanas, negócios e artes
                            para dar a você as sugestões mais relevantes.</p>
                        <p>Trinka é desenvolvido por uma equipe de lingüistas, editores médicos, cientistas de dados e engenheiros
                            com um profundo desejo de criar um futuro com comunicação sem barreiras.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>Transforme sua comunicação empresarial com Trinka</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">Obtenha uma Cotação</button>
</div>


<app-enterprise-modal></app-enterprise-modal>